import {
  AfterViewInit,
  Component,
  Inject,
  Input, OnDestroy,
  OnInit,
  Optional
} from '@angular/core';
import {SitesService} from "../../services/sites.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../../interfaces/dialog';
import {SelectOption, SelectOptions} from '../../interfaces/form';
import {FormValidators} from '../../validators/form-validators';
import {DataSetValidator} from '../../validators/data-set-validator';
import {
  createFirstSite,
  createSite,
  createSiteSuccess,
  updateSite,
  updateSiteSuccess
} from "../../store/sites/sites.actions";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/store";
import {DialogFormStore} from "../../store/dialog/dialogForm.store";
import {Observable} from "rxjs";
import {selectSitesLoading} from "../../store/sites/sites.selectors";

@Component({
  selector: 'app-site-form',
  templateUrl: './site-form.component.html',
  styleUrls: ['./site-form.component.scss'],
  providers: [DialogFormStore]
})
export class SiteFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input('showTitle') public showTitle: boolean = true;
  @Input('customClass') public customClass: string;

  public timezones: Array<string> = ['Africa/Abidjan','Africa/Accra','Africa/Algiers','Africa/Bissau','Africa/Cairo','Africa/Casablanca','Africa/Ceuta','Africa/El_Aaiun','Africa/Johannesburg','Africa/Khartoum','Africa/Lagos','Africa/Maputo','Africa/Monrovia','Africa/Nairobi','Africa/Ndjamena','Africa/Tripoli','Africa/Tunis','Africa/Windhoek','America/Anchorage','America/Araguaina','America/Argentina/Buenos_Aires','America/Asuncion','America/Bahia','America/Barbados','America/Belem','America/Belize','America/Boa_Vista','America/Bogota','America/Campo_Grande','America/Cancun','America/Caracas','America/Cayenne','America/Chicago','America/Costa_Rica','America/Cuiaba','America/Curacao','America/Danmarkshavn','America/Dawson_Creek','America/Denver','America/Edmonton','America/El_Salvador','America/Fortaleza','America/Godthab','America/Grand_Turk','America/Guatemala','America/Guayaquil','America/Guyana','America/Halifax','America/Havana','America/Hermosillo','America/Iqaluit','America/Jamaica','America/La_Paz','America/Lima','America/Los_Angeles','America/Maceio','America/Managua','America/Manaus','America/Martinique','America/Mazatlan','America/Mexico_City','America/Miquelon','America/Montevideo','America/Nassau','America/New_York','America/Noronha','America/Panama','America/Paramaribo','America/Phoenix','America/Port-au-Prince','America/Port_of_Spain','America/Porto_Velho','America/Puerto_Rico','America/Punta_Arenas','America/Recife','America/Regina','America/Rio_Branco','America/Santiago','America/Santo_Domingo','America/Sao_Paulo','America/Scoresbysund','America/St_Johns','America/Tegucigalpa','America/Thule','America/Tijuana','America/Toronto','America/Vancouver','America/Whitehorse','America/Winnipeg','America/Yellowknife','Antarctica/Casey','Antarctica/Davis','Antarctica/DumontDUrville','Antarctica/Mawson','Antarctica/Palmer','Antarctica/Rothera','Antarctica/Syowa','Antarctica/Vostok','Asia/Almaty','Asia/Amman','Asia/Aqtau','Asia/Aqtobe','Asia/Ashgabat','Asia/Baghdad','Asia/Baku','Asia/Bangkok','Asia/Beirut','Asia/Bishkek','Asia/Brunei','Asia/Choibalsan','Asia/Colombo','Asia/Damascus','Asia/Dhaka','Asia/Dili','Asia/Dubai','Asia/Dushanbe','Asia/Gaza','Asia/Hong_Kong','Asia/Hovd','Asia/Irkutsk','Asia/Jakarta','Asia/Jayapura','Asia/Jerusalem','Asia/Kabul','Asia/Kamchatka','Asia/Karachi','Asia/Kathmandu','Asia/Kolkata','Asia/Krasnoyarsk','Asia/Kuala_Lumpur','Asia/Macau','Asia/Magadan','Asia/Makassar','Asia/Manila','Asia/Nicosia','Asia/Omsk','Asia/Pyongyang','Asia/Qatar','Asia/Riyadh','Asia/Saigon','Asia/Seoul','Asia/Shanghai','Asia/Singapore','Asia/Taipei','Asia/Tashkent','Asia/Tbilisi','Asia/Tehran','Asia/Thimphu','Asia/Tokyo','Asia/Ulaanbaatar','Asia/Vladivostok','Asia/Yakutsk','Asia/Yangon','Asia/Yekaterinburg','Asia/Yerevan','Atlantic/Azores','Atlantic/Bermuda','Atlantic/Canary','Atlantic/Cape_Verde','Atlantic/Faroe','Atlantic/Reykjavik','Atlantic/South_Georgia','Atlantic/Stanley','Australia/Adelaide','Australia/Brisbane','Australia/Darwin','Australia/Hobart','Australia/Perth','Australia/Sydney','Etc/GMT','Europe/Amsterdam','Europe/Andorra','Europe/Athens','Europe/Belgrade','Europe/Berlin','Europe/Brussels','Europe/Bucharest','Europe/Budapest','Europe/Chisinau','Europe/Copenhagen','Europe/Dublin','Europe/Gibraltar','Europe/Helsinki','Europe/Istanbul','Europe/Kaliningrad','Europe/Kiev','Europe/Lisbon','Europe/London','Europe/Luxembourg','Europe/Madrid','Europe/Malta','Europe/Minsk','Europe/Monaco','Europe/Moscow','Europe/Oslo','Europe/Paris','Europe/Prague','Europe/Riga','Europe/Rome','Europe/Samara','Europe/Sofia','Europe/Stockholm','Europe/Tallinn','Europe/Tirane','Europe/Vienna','Europe/Vilnius','Europe/Warsaw','Europe/Zurich','Indian/Chagos','Indian/Christmas','Indian/Cocos','Indian/Kerguelen','Indian/Mahe','Indian/Maldives','Indian/Mauritius','Indian/Reunion','Pacific/Apia','Pacific/Auckland','Pacific/Chuuk','Pacific/Easter','Pacific/Efate','Pacific/Enderbury','Pacific/Fakaofo','Pacific/Fiji','Pacific/Funafuti','Pacific/Galapagos','Pacific/Gambier','Pacific/Guadalcanal','Pacific/Guam','Pacific/Honolulu','Pacific/Kiritimati','Pacific/Kosrae','Pacific/Kwajalein','Pacific/Majuro','Pacific/Marquesas','Pacific/Nauru','Pacific/Niue','Pacific/Norfolk','Pacific/Noumea','Pacific/Pago_Pago','Pacific/Palau','Pacific/Pitcairn','Pacific/Pohnpei','Pacific/Port_Moresby','Pacific/Rarotonga','Pacific/Tahiti','Pacific/Tarawa','Pacific/Tongatapu','Pacific/Wallis','Pacific/Wake'];
  public currencies: SelectOptions<string, string> = [];
  private defaultTimezone: string = 'Europe/Paris';
  private defaultCurrency: string = 'eur';
  public image: string;
  public form: FormGroup = new FormGroup(
    {
      name: new FormControl('', [Validators.required, Validators.minLength(3)]),
      currency: new FormControl(this.defaultCurrency, [Validators.required]),
      timezone: new FormControl(this.defaultTimezone, [Validators.required]),
      image: new FormControl(null)
    }
  );

  public loading$: Observable<boolean> = this._popinStore.loading$;
  public sitesLoading$: Observable<boolean> = this._store.select(selectSitesLoading);

  constructor(
    private dataSetsS: SitesService,
    @Optional() public readonly dialogRef: MatDialogRef<SiteFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly _store: Store<AppState>,
    private readonly _popinStore: DialogFormStore
  ) {}

  ngOnInit(): void {
    this.currencies = this.dataSetsS.getCurrencies();
    this._initForm();

    if (this.dialogRef) {
      this._popinStore.init(
        this.form,
        this.dialogRef,
        [createSite, updateSite],
        [createSiteSuccess, updateSiteSuccess],
      );
    }
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  private _initForm(): void {
    if (this.data && this.data.site) {
      this.data.site.attributes.image = this.data.site.attributes?.parameters?.image;
      this.form.get('image').setValue(this.data.site.attributes?.parameters?.image || null);
      this.form.get('name').setValue(this.data.site.attributes.name);
      this.form.get('currency').setValue(this.data.site.attributes.currency);
      this.form.get('timezone').setValue(this.data.site.attributes.timezone);
      this.form.get('name').disable();
      this.form.get('currency').disable();
      this.form.get('timezone').disable();
      this.form.setValidators(FormValidators.formIsValid(this.data.site.attributes));
      this.form.updateValueAndValidity();
    }

    this.form.get('name').setAsyncValidators([DataSetValidator.validateName(this.dataSetsS, this.data?.site?.attributes.name || null)]);
  }

  public valueGetter(option: SelectOption<any, any>): string {
    return option.key;
  }

  public onCreate(): void {
    if (this.dialogRef) {
      this._store.dispatch(createSite({ site: this.form.value }));
    } else {
      this._store.dispatch(createFirstSite({ site: this.form.value }));
    }
  }

  public onModify(): void {
    this._store.dispatch(updateSite({ site: this.data.site, update: this.form.value }));
  }

  public onImageAdded(image: string): void {
    this.form.get('image').setValue(image);
  }

}
